import currency from 'currency.js';
import _ from 'lodash';

import Component from '../classes/component';

class Price extends Component {
  public isValidPrice() {
    const hasSubscript = !!this.container.getElementsByTagName('sup').length;
    const endsWithDollarSign = this.container.innerText.endsWith('$');

    return hasSubscript && endsWithDollarSign;
  }

  public getContent():
    | { isValidPrice: true; value: number }
    | { isValidPrice: false; value: string } {
    const isValidPrice = this.isValidPrice();

    if (isValidPrice) {
      return {
        isValidPrice: true,
        value: currency(this.container.innerText, { decimal: ',' }).value,
      };
    }

    return { isValidPrice: false, value: this.container.innerText };
  }

  private _getRegularPrice(value?: number): string {
    if (!value) return '';
    const price = currency(value, { symbol: '$', decimal: ',', pattern: '# !' }).format();
    return `<span class="regular-price">${price}</span>`;
  }

  private _getCurrentPrice(value: number, regularValue?: number) {
    const [dollars, cents] = currency(value, { symbol: '' }).format().split('.');
    return `${dollars},<sup>${cents}$${this._getRegularPrice(regularValue)}</sup>`;
  }

  public setValue(value: number, discountedPrice?: number): void {
    this.container.innerHTML = _.isNumber(discountedPrice)
      ? this._getCurrentPrice(discountedPrice, value)
      : this._getCurrentPrice(value);
  }
}

export default Price;
